// extracted by mini-css-extract-plugin
module.exports = {"dashboard-content":"Dashboard_dashboard-content__2S0f5"};